import type { PullRequestState } from "../../../convex/lib/issueValidators"

/**
 * The Pull requests page as the URL holds it: which state is listed, and
 * which pull request is open beside the list. Open is the state the bare
 * address shows, so it is never written. `repo` ("owner/name") is only
 * written for a project with several repositories, where a number alone
 * names several pull requests.
 */
export const PULL_REQUEST_STATES = [
  "open",
  "merged",
  "closed",
] as const satisfies readonly PullRequestState[]

export type PullsSearch = {
  state?: Exclude<PullRequestState, "open">
  pr?: number
  repo?: string
}

const MAX_REPO_LENGTH = 200

/** Whatever the URL says, a page that can be drawn: it never throws. */
export function parsePullsSearch(search: Record<string, unknown>): PullsSearch {
  const parsed: PullsSearch = {}
  if (search.state === "merged" || search.state === "closed") parsed.state = search.state
  const number = typeof search.pr === "string" ? Number(search.pr) : search.pr
  if (typeof number === "number" && Number.isSafeInteger(number) && number > 0) {
    parsed.pr = number
    if (
      typeof search.repo === "string" &&
      search.repo.length <= MAX_REPO_LENGTH &&
      /^[^/\s]+\/[^/\s]+$/.test(search.repo)
    ) {
      parsed.repo = search.repo
    }
  }
  return parsed
}
